import React, { useState } from 'react';
import { EventListType } from '../../Enums/eventListType.enum';
import EventList from '../EventList/EventList';
import PatientAsyncSelect from '../../../Patient/Components/PatientAsyncSelect/PatientAsyncSelect';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import styles from './EventListWithSearch.module.scss';
import Label from '../../../../Components/Base/Label/Label';
import Input from '../../../../Components/Form/components/Input';

interface Props {
	handleShowEventInCalendar: (eventId: string) => void;
}

const EventListWithSearch: React.FC<Props> = ({
	handleShowEventInCalendar,
}) => {
	const [fulltext, setFulltext] = useState<string | undefined>();

	return (
		<div className={styles.wrapper}>
			<div className={styles.searchWrapper}>
				<Label tx='component.eventListWithSearch.searchLabel' />
				<Input
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setFulltext(e.target.value);
					}}
				/>
			</div>
			{fulltext && (
				<EventList
					key='patientsOrders'
					fulltext={fulltext}
					handleShowEventInCalendar={handleShowEventInCalendar}
					type={EventListType.FUTURE}
				/>
			)}
		</div>
	);
};

export default EventListWithSearch;
